/* eslint-disable rxjs-angular-x/prefer-composition */
import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { EMPTY, Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import { Context, LOCALE, REQUEST, RESPONSE, WINDOW } from "@hermes/core-app-core";
import { redirectResponse } from "@hermes/core-response-service";
import { LOGGER } from "@hermes/core-web-logger";

import { InterceptorService } from "./interceptor.service";

/**
 * This interceptor redirects to homepage if intercept a 410 http error (ex: product is gone)
 */
@Injectable()
export class RedirectOn410GoneInterceptor implements HttpInterceptor {
    private readonly interceptorService = inject(InterceptorService);
    private readonly request = inject(REQUEST, { optional: true });
    private readonly response = inject(RESPONSE, { optional: true });
    private readonly context = inject(Context);
    private readonly logger = inject(LOGGER);
    private readonly locale = inject(LOCALE);
    private readonly window = inject<Window>(WINDOW);

    /**
     * Angular HTTP interceptor
     */
    public intercept<T>(
        request: HttpRequest<T>,
        next: HttpHandler,
    ): Observable<HttpEvent<T>> {
        // If the current interceptor is disabled for current route,
        // we only call next.handle without any custom process
        if (!this.interceptorService.isEnabled(this)) {
            return next.handle(request);
        }

        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse): Observable<never> => {
                if (error.status === 410) {
                    // in server mode, redirect to home page
                    if (
                        this.context.isInServerMode() &&
                        this.response &&
                        this.request
                    ) {
                        this.logger.info(error.message);
                        redirectResponse({
                            request: this.request,
                            response: this.response,
                            newPath: this.locale.urlPrefix,
                            forceCleanQueryParameters: true,
                        });
                        return EMPTY;
                    }
                    // in browser mode, we don't use router service and leave
                    // traffic switcher redirects to cms or rdr home page
                    this.window.location.href = `${this.locale.urlPrefix}/`;
                    return EMPTY;
                }

                // default case : technical error, rethrow the error so that it can be catched by the susbscribers or ErrorHandler if there is no error management on call
                return throwError(() => error);
            }),
        );
    }
}
